import { MoreIcon } from '@contra/icons/icons';
import { styled } from 'styled-components';

export const StyledMoreIcon = styled(MoreIcon)`
  position: relative;
  left: 1px;
`;
